<template>
  <div class="con login-out">
    <div class="right">
      <div class="right-top">
        <div class="title">营口市艾滋病干预 登录界面</div>
      </div>
      <div class="right-right">
        <div class="cell-z">
          <div class="span-a">账号</div>
          <el-input v-model="queryData.u_name" />
        </div>
        <div class="cell-z">
          <div class="span-a">密码</div>
          <el-input v-model="queryData.u_pwd" type="password" />
        </div>
        <el-button type="primary" class="button" size="large" @click="_login"
          >登 录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { ElMessage, ElMessageBox } from 'element-plus'
import { login, checkToken, loginStatus } from '@/api/index'
import Cookies from 'js-cookie'

const { body } = document
// let interval = undefined
export default {
  name: 'loginView',
  components: {},
  mounted() {
    this._checkToken()
  },
  data() {
    return {
      intervalTotal: 0,
      intervalTarget: 40,
      queryData: {
        u_name: undefined,
        u_pwd: undefined
      }
    }
  },
  methods: {
    _checkToken() {
      checkToken().then(res => {
        console.log(res)
        if (res.code === 200) {
          Cookies.set('token', res.data)
          this._loginStatus()
        }
      })
    },
    _login() {
      if (!this.queryData.u_name) {
        ElMessage.warning('账号必须填写')
        return
      }

      if (!this.queryData.u_pwd) {
        ElMessage.warning('密码必须填写')
        return
      }

      login(this.queryData).then(res => {
        if (res.code === 200) {
          ElMessage.success(res.description)
          this._toHome()
        } else {
          ElMessage.warning(res.description)
        }
      })
    },
    // 判断登录状态
    _loginStatus() {
      loginStatus().then(res => {
        if (res.code === 200) {
          // 已登录
          ElMessage.success('已登录')
          this._toHome()
        } else {
          // 尚未登录
          ElMessage.warning(res.description)
        }
      })
    },
    _toHome() {
      this.$router.push({
        path: '/reports'
      })
    }
  }
}
</script>

<style scoped>
.right {
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 10px 10px 5px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

.right-top {
  width: 100%;
  padding: 20px 0;
  background: #007bff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.right-top .title {
  color: #ffffff;
  font-weight: bold;
  font-size: 22px;
}

.right-right {
  margin: 0 40px;
  height: 100%;
  flex: 1;
  background: #ffffff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10% 0 30% 0;
}

.con {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
}

.login-out {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  background-image: url(@/assets/loginBackground.png);
}

.cell-z .span-a {
  width: 100%;
  margin-right: 10px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  margin-bottom: 6px;
  font-size: 18px;
}

.cell-z .span-b {
  width: 100%;
  margin-right: 10px;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: auto;
  font-size: 30px;
  margin-bottom: 6px;
  color: #333333;
}

.cell-z {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 300px;
  margin-bottom: 20px;
}

.row-con {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.button {
  width: 100%;
  height: 40px;
  margin-top: 30px;
  font-size: 16px;
}

.el-input__inner {
  border: none;
  color: #333333;
}
</style>
